module.exports = __webpack_public_path__ + "img/flower-yellow.4526026c.png";